import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { IconButton } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import ConfirmationModal from "views/components/ConfirmationModal";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgress from "components/CircularProgress/CircularProgresss";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ToastModal from "views/components/ToastModal";

const Lender = (props) => {
  const navigate = useNavigate();
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [tableColumns, setTableColumns] = useState([
    { id: "id", label: "S. NO." },
    { id: "name", label: "Name" },
    { id: "action", label: "Actions" },
  ]);
  const [rawData, setRawData] = useState([]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [deleteLenderId, setDeleteLenderId] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const handleCreateLender = async () => {
    navigate(`/coreservice/Lender-create`);
  };

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.LENDER_FINDALL,
      authToken: authToken,
    });
    setCallInProgress(false);

    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setRawData(result?.data);
      parseIndicatorData(result?.data);
    }
  };

  // parseIndicatorData function
  const parseIndicatorData = (data) => {
    let reportData = [];
    data.forEach((pin, i) => {
      let row = {
        id: i + 1,
        name: pin.name,
        action: getIcons(pin.id),
      };
      reportData.push(row);
    });
    setSelectedTableData(reportData);
  };
  // icons function calling
  const getIcons = (code) => {
    return (
      <>
        <IconButton
          aria-label="Edit Branch"
          onClick={() => onClickEditData(code)}
        >
          <EditIcon />
        </IconButton>
        <IconButton
          aria-label="Delete Branch"
          onClick={() => onClickDeleteData(code)}
        >
          <DeleteIcon />
        </IconButton>
      </>
    );
  };
  const onClickEditData = (code) => {
    navigate(`/coreservice/Lender-create/` + code);
  };
  const onClickDeleteData = (code) => {
    setConfirmationModalHeader("Lender");
    setConfirmationModalMsg("Are you sure you want to delete this entry");
    setDeleteLenderId(code);
    setConfirmationModal(true);
  };
  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setDeleteLenderId("");
  };
  const handlePositiveResponse = async () => {
    handleNegativeResponse();
    // Call API to delete Branch
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.LENDER_DELETE + deleteLenderId,
      method: "DELETE",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      toastUpdate("Error", "Delete Lender is successful", true);
      getData();
    }
  };

  // search function calling
  const onSearchChange = (event) => {
    const filteredData = rawData.filter((row) => {
      const val = event.target.value;
      return row.name && row.name.toLowerCase().includes(val.toLowerCase());
    });
    parseIndicatorData(filteredData);
  };
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
      setToast(showToast);
  };
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <SubHeader
          label="Lender"
          button1="Create Lender"
          button1click={handleCreateLender}
          onSearchChange={onSearchChange}
          searchLabel="Search For Lender"
          search
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={12}>
        <ColumnGroupingTable columns={tableColumns} rows={selectedTableData} />
      </GridItem>
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
      {callInProgress && <CircularProgress callInProgress={callInProgress} />}
      <ConfirmationModal
        confirmationModal={confirmationModal}
        confirmationModalHeader={confirmationModalHeader}
        confirmationModalMsg={confirmationModalMsg}
        handleNegativeButton={handleNegativeResponse}
        handlePositiveButton={handlePositiveResponse}
      />
    </GridContainer>
  );
};
Lender.propTypes = {
  classes: PropTypes.object,
};

export default Lender;
